import { BaseComponent } from "utils/base-component"
import { getCurrentGeo } from "utils/geolocation"

import "./index.scss"
import Icon from "./static/nearby-location--blue.svg"
import "./static/nearby-location--white.svg"

declare namespace FCGON {
  const nearestLocationPath: string
}

type Config = {
  nearestPath?: string
  fallbackPath?: string
  positionDetermined?: (pos: GeolocationPosition) => void
}

export class Nearby extends BaseComponent<Config> {
  static cssClass = "nearby"

  init(creating?: boolean) {
    if (creating) {
      this.root.setAttribute("rel", "nofollow")
      this.root.setAttribute("tabindex", "0")

      const img = document.createElement("img")
      img.src = Icon
      img.classList.add(this.elementClassName("icon"))
      this.root.appendChild(img)

      this.root.appendChild(document.createTextNode("Nearest"))
    } else {
      this.config.nearestPath = this.root.dataset.nearestPath
      this.config.fallbackPath = (this.root as HTMLAnchorElement).href
    }

    if (!this.config.fallbackPath) this.config.fallbackPath = FCGON.nearestLocationPath
    if (!this.config.nearestPath) this.config.nearestPath = "/location_search"

    this.root.addEventListener("click", (e) => {
      e.preventDefault()

      getCurrentGeo(
        (pos) => {
          const callback = this.config?.positionDetermined
          if (callback) callback(pos)

          this.redirectToNearest(pos)
        },
        () => this.fallback(),
      )
    })
  }

  redirectToNearest(position: GeolocationPosition) {
    const { latitude, longitude } = position.coords
    window.location.href = `${this.config.nearestPath}?lat=${latitude}&lon=${longitude}`
  }

  fallback() {
    const path = this.config.fallbackPath
    if (path) {
      window.location.href = path
    } else {
      // eslint-disable-next-line no-alert
      alert("Failed to determine your location.")
    }
  }
}
